<template>
  <!-- mesRelevanceDevice 单品能耗 -->
  <div class="energy-flow">

    <div class="con">
      <div class="tree-left">
        <div class="search">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        </div>
        <div class="btns">
          <el-button type="primary" size="mini" @click="popupFn('add')">地址管理</el-button>
        </div>
        <div class="scroll" style="width:100%;height:93%">
          <el-scrollbar style="height:95%;width: 100%;">
            <el-tree :data="leftData" ref="leftTree" :props="defaultProps1" @node-click="leftTreeClick"
              highlight-current :expand-on-click-node="true" node-key="id" :filter-node-method="filterNode"
              :default-expanded-keys="defaultExpanded" :current-node-key='defaultDevice'>
              <span class="custom-tree-node" slot-scope="{node}" style="display: flex;align-items: center;">
                <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;"
                  v-if="node.data.category == 1" />
                <img src="../../../public/static/image/elTree/group.png" style="margin-right: 2px;" v-else />
                <span style="padding-left: 5px;">{{node.data.uniqueName}} </span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div class="content">
        <div style="display: flex;">
          <div class="mytable">
            <el-table ref="multipleTable" :data="tableData" stripe tooltip-effect="dark" style="width: 100%"
              :max-height="heights" border highlight-current-row @current-change="handleSelectionChange">
              <template slot="empty">
                <span class="noData">
                  <img src="../../assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column width="90" align="center" label="序号">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="id" label="id" />
              <el-table-column prop="divId" label="设备id" />
              <el-table-column label="设备名称" width="180">
                <template slot-scope="scope">{{ scope.$index + 1 }}号设备</template>
              </el-table-column>
            </el-table>
          </div>
          <div class="conten-btns">
            <div class="left-add" @click="device_Add">添加<img src="../../assets/left.png" alt=""></div>
            <div class="del-btn-transfer" @click="device_Del">移除<img src="../../assets/right.png" alt=""></div>
          </div>
        </div>
      </div>
      <div class="tree-right">
        <div class="search">
          <el-input placeholder="输入关键字进行过滤" v-model="filterTextRight"></el-input>
        </div>
        <div class="scroll" style="width:100%;height:93%">
          <el-scrollbar style="height:100%;width: 100%;">
            <el-tree :data="rightData" show-checkbox node-key="num" :props="defaultProps" @check="currentChecked"
              :filter-node-method="filterNodeRight" ref="tree">
              <span class="custom-tree-node" slot-scope="{node}">
                <img src="../../../public/static/image/elTree/1.9.png"
                  v-if="node.data.Content.Category=='Organization'" />
                <img src="../../../public/static/image/elTree/2.1.png" v-else />
                <span style="padding-left: 5px;">{{node.data.Content.Name}}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>

      </div>
    </div>

    <!-- 新增修改 -->
    <el-dialog v-dialogDrag title="地址管理" :close-on-click-modal='false' :visible.sync="dialogVisible" width="600px">
      <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="90px" class="demo-dynamic">
        <el-form-item prop="remoteUrl" label="接口地址" :rules="[
            { required: true, message: '请输入接口地址', trigger: 'blur' }, 
          ]">
          <span style="display: flex;">
            <el-input v-model="dynamicValidateForm.remoteUrl"></el-input>
            <el-button type="primary" v-if="dynamicValidateForm.status == 'DISABLE'" @click="remoteStatus('ENABLE')">启
              用</el-button>
            <el-button type="warning" v-if="dynamicValidateForm.status == 'ENABLE'" @click="remoteStatus('DISABLE')">禁
              用</el-button>
          </span>
        </el-form-item>
        <el-form-item prop="requestType" label="请求类型" :rules="[
        { required: true, message: '请选择请求类型', trigger: 'change' }, 
      ]">

          <el-radio v-model="dynamicValidateForm.requestType" label="GET">GET</el-radio>
          <el-radio v-model="dynamicValidateForm.requestType" label="POST">POST</el-radio>
        </el-form-item>
        <el-form-item v-for="(domain, index) in dynamicValidateForm.addressParameter" :label="'键值' + index"
          :key="index">

          <span style="display: flex ;">
            <el-input v-model="domain.key" placeholder="键"></el-input><el-input v-model="domain.value"
              placeholder="值"></el-input><el-button @click.prevent="removeDomain(domain)">删除</el-button>
          </span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('dynamicValidateForm')">提交</el-button>
          <el-button @click="addDomain">新增键值</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>

  import {getReadDeviceTree} from "../../api/abbNewApi";
  import {findModelTree,saveDissipation,updateDissipation,deleteDissipation,dissipaFinDevice,dissipationSave,dissipationRemove} from "../../api/dissipation";
  // import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import request from "@/api/http.js";
  export default {
    data () {
      return {
        dynamicValidateForm: {
          addressParameter: [{
            "key": "",
            "value": ''
          }],
        },

        diveName: {},//设备名称
        heights: document.getElementById('app').clientHeight-140,
        loading: false,
        dialogStatus: "新增",//弹窗类型
        radio: "能流分析",//单选框

        leftData: [{
          uniqueName: '应用数据'
        },{
          uniqueName: '应用数据'
        },{
          uniqueName: '应用数据'
        },{
          uniqueName: '应用数据'
        },{
          uniqueName: '应用数据'
        },{
          uniqueName: '应用数据'
        },{
          uniqueName: '应用数据'
        },{
          uniqueName: '应用数据'
        }],//左边树形结构数据
        rightData: [{
          Content: {
            Name: '2号设备'
          }
        }],//右边树形结构树形
        defaultProps1: {
          children: 'mesTreeChild',
          label: 'uniqueName'
        },
        defaultProps: {
          children: 'ChildDatas',
          label: 'Content.Name'
        },
        filterText: '',
        filterTextRight: "",
        tableData: [{
          id: '1',
          divId: '001',
        },{
          id: '2',
          divId: '002',
        },{
          id: '3',
          divId: '003',
        },{
          id: '4',
          divId: '004',
        },{
          id: '5',
          divId: '005',
        }],
        multipleSelection: '',
        rules: {
          code: [
            {required: true,message: '请输入编号',trigger: 'blur'}
          ],
          modelName: [
            {required: true,message: '请输入名称',trigger: 'blur'}
          ],
          modelType: [
            {required: true,message: '请输入类型',trigger: 'blur'}
          ],
        },
        temp: {
          modelName: "",
          modelType: "",
        },
        dialogVisible: false,
        unitItem: '',
        tag: 1,//判断点击的是单位/能流图/节点
        nodeItem: [],//节点
        checkedNodes: [],
        halfCheckedNodes: null,
        nowNode: "",
        defaultExpanded: [],
        defaultDevice: "",
        firstItem: "",
      }
    },
    watch: {
      filterText (val) {
        this.$refs.leftTree.filter(val);
      },
      filterTextRight (val) {
        this.$refs.tree.filter(val);
      },
      unitId () {
        this.findUnitInfoFun()
      }

    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      }
    },
    mounted () {
      var num=0
      getReadDeviceTree().then(res => {
        // console.log("设备列表",res);
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.ChildDatas.length!=0) {
                row['num']=num++
                getStr(row.ChildDatas)
              } else {
                row['num']=num++
                row['disabled']=false
                // str += row.Content.Name + ";"
                // row.ChildDatas = row.Content.groups
              }
            })
          }
          getStr(res.data)
        }
        recursiveFunction()
        this.rightData=res.data
      })
    },
    beforeDestroy () {
      this.nodeItem=[]
    },
    methods: {
      //禁用跟启用
      remoteStatus (type) {
        var params={
          dateStatus: type,
          id: this.dynamicValidateForm.id
        }
        var str=type=='ENABLE'? '启用':'禁用';

        request({url: "/capacity/remote/status",method: "put",params}).then(res => {
          if(res.code==200) {
            this.$message({showClose: true,message: `${str}成功`,type: 'success'});
            this.$set(this.dynamicValidateForm,'status',type)
          } else {
            res.message? this.$message.error(res.message):this.$message.error('失败')
          }
        })
        return
        capacityStatusRemote(d).then(res => {
          if(res.code==200) {
            this.dialogAddress=false
            this.remote_fn()
            this.$message({showClose: true,message: `${str}成功`,type: 'success'});
          } else {
            res.message? this.$message.error(res.message):this.$message.error(`${str}失败`)
          }
        })
      },
      submitForm (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            var data={
              addressParameter: this.dynamicValidateForm.addressParameter,
              id: this.dynamicValidateForm.id,
              remoteUrl: this.dynamicValidateForm.remoteUrl,
              requestType: this.dynamicValidateForm.requestType,
              unitId: this.unitId.id
            };
            request({url: "/capacity/remote/save",method: "post",data}).then(res => {
              if(res.code==200) {
                this.$message.success('操作成功');
                this.dialogVisible=false;
              } else {
                res.message? this.$message.error(res.message):this.$message.error('失败')
              }
            })
          }
        });
      },
      removeDomain (item) {
        var index=this.dynamicValidateForm.addressParameter.indexOf(item)
        if(index!==-1) {
          this.dynamicValidateForm.addressParameter.splice(index,1)
        }
      },
      addDomain () {
        this.dynamicValidateForm.addressParameter.push({
          value: '',
          key: ''
        });
      },
      //左边树形结构筛选
      filterNode (value,data) {

        if(!value) return true;
        return data.modelName.indexOf(value)!==-1;
      },
      //右边树形结构筛选
      filterNodeRight (value,data) {
        if(!value) return true;
        return data.Content.Name.indexOf(value)!==-1;
      },
      //表格全选反选
      toggleSelection (rows) {
        if(rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange (val) {
        console.log(val);
        this.multipleSelection=val;
      },
      //左边树形结构数据
      findUnitInfoFun () {

      },
      //左边数据结构点击
      leftTreeClick (item) {
        this.unitItem=item;
        console.log(item.deviceRelevanceList);
        var d=[]
        this.tableData=[]
        for(const key in item.deviceRelevanceList) {
          d.push(item.deviceRelevanceList[key]);
          this.tableData.push({
            id: key,
            divId: item.deviceRelevanceList[key]
          })
        }


        this.diveName={};//设备名称
        var a=this.rightData;
        var b=this.diveName;

        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.ChildDatas.length!=0) {
                getStr(row.ChildDatas)
              } else {
                row.disabled=false
                d.forEach(item => {
                  if(row.Content.Id==item) {
                    b[row.Content.Id]=row.Content.Name;//设备名称
                    row.disabled=true
                  }
                })

              }
            })
          }
          getStr(a)
        }
        recursiveFunction()



      },
      //获取能流图列表
      getDeviceList (ids) {
        var params={deviceId: ids}

        request({url: "/gyMes/getProductByDeviceId",method: "get",params}).then(res => {
          this.loading=false
          if(res.code==200) {
            this.tableData=res.data;


          } else {
            res.message? this.$message.error(res.message):this.$message.error('失败')
          }
        })
        return

        dissipaFinDevice({"id": ids}).then(res => {
          if(res.code==200) {

            this.tableData=res.data
            var a=this.rightData
            var recursiveFunction=function() {
              const getStr=function(list) {
                list.forEach(function(row) {
                  if(row.ChildDatas.length!=0) {
                    // console.log("row.ChildDatas",row);
                    getStr(row.ChildDatas)
                  } else {
                    row.disabled=false
                    res.data.forEach(item => {
                      if(row.Content.Id==item.deviceNo) {
                        row.disabled=true
                      }
                    })

                  }
                })
              }
              getStr(a)
            }
            recursiveFunction()
            // console.log("rightData",this.rightData.filter(item => item.Id == '1'));
            this.loading=false
            this.$nextTick(() => {
              //清除选中
              this.$refs['tree'].setCheckedKeys([]);

            })
          } else {
            this.$message({type: 'warning',message: '获取失败'});
            this.loading=false
          }
        })
      },
      //地址管理弹窗
      popupFn (type) {
        var params={unitId: this.unitId.id}
        this.dialogVisible=true;
        request({url: "/capacity/remote/findById",method: "get",params}).then(res => {
          this.loading=false
          if(res.code==200) {
            if(res.data) {
              this.dynamicValidateForm=res.data;
            }

            if(!this.dynamicValidateForm.addressParameter) {
              this.$set(this.dynamicValidateForm,'addressParameter',[])
            }
            this.$nextTick(() => {
              this.$refs["dynamicValidateForm"].clearValidate();
            });
          } else {
            res.message? this.$message.error(res.message):this.$message.error('失败')
          }
        })


      },
      //添加成功提示
      addSuccess (type) {
        if(type=='新增') {
          this.$message({type: 'success',message: '添加成功!'});
        } else {
          this.$message({type: 'success',message: '修改成功!'});
        }

        this.temp.modelName=""
        this.temp.modelType=""
        this.dialogVisible=false
      },
      //新增修改
      determine_Fn (type) {
        console.log(this.unitId.id);
        return
        this.$refs['temp'].validate(valid => {
          if(valid) {
            if(type=='新增') {
              //新增模型
              //顶级为 0 ，否则为自己本身
              var data={
                'code': this.temp.code,
                'modelName': this.temp.modelName,
                'modelType': this.temp.modelType,
                'parentId': this.unitItem.id==this.firstItem? 0:this.unitItem.id,
                'unitId': this.unitId.id,
              }

              console.log(data);
              request({url: "/dissipation/model/save",method: "post",data}).then(res => {
                if(res.code==200) {
                  this.addSuccess(type)
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('添加失败')
                }
              })
              // saveDissipation(d).then(res => {
              //   if(res.code==200) {
              //     this.addSuccess(type)
              //   } else {
              //     res.message? this.$message.error(res.message):this.$message.error('添加失败')
              //   }
              // })


            } else if(type=='修改') {
              // /dissipation/model/update
              this.temp.children=[]
              updateDissipation(this.temp).then(res => {
                if(res.code==200) {
                  this.addSuccess(type)
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('修改失败')
                }
              })
            }

          } else {
            return false;
          }
        });


      },
      //删除操作
      delFun () {
        if(this.unitItem.length==0) {
          this.$message({type: 'warning',message: '请选择节点'});
          return
        }

        var d='';
        if(this.unitItem.modelType=='AREA') {
          d='区域'
        }
        if(this.unitItem.modelType=='PROCESS') {
          d='工序'
        }
        if(this.unitItem.modelType=='PRODUCTION') {
          d='产线'
        }
        if(this.unitItem.modelType=='WORKSHOP') {
          d='车间'
        }
        if(this.unitItem.modelType=='PT') {
          d='点位'
        }
        this.$confirm(`是否删除该 ${this.unitItem.modelName}(${d})?`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteDissipation({'id': this.unitItem.id}).then(res => {
            if(res.code==200) {
              this.$message({type: 'success',message: `删除 ${this.unitItem.modelName}(${d}) 成功!`});
            }

          })


        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      //移除能流图节点的关联设备
      device_Del () {
        if(!this.multipleSelection) {
          this.$message({type: 'warning',message: '请勾选需要删除的设备!'});
          return
        }

        var params={
          'relevanceId': this.multipleSelection.id,
        }
        request({url: "/gyMes/deleteDeviceRelevance",method: "delete",params}).then(res => {
          if(res.code==200) {
            this.$message({type: 'success',message: '移除成功!'});
          } else {
            this.$message({type: 'error',message: `移除失败,${res.message}`});
          }
        })
        return

        dissipationRemove(d).then(res => {
          if(res.code==200) {
            this.$message({type: 'success',message: '移除成功!'});
            this.getDeviceList(this.unitItem.id)
          } else {
            this.$message({type: 'error',message: `移除失败,${res.message}`});
          }
        })

      },
      //树形结构选中节点
      currentChecked (nodeObj,SelectedObj) {
        var mycheckedNodes=SelectedObj.checkedNodes
        this.checkedNodes=mycheckedNodes.filter(item => item.Content.Category=='Device')
      },
      //添加能流图节点的关联设备
      device_Add () {
        //  console.log(this.nodeItem);
        if(!this.unitItem.id) {
          this.$message({type: 'warning',message: '请选择设备!'});
          return
        }
        if(this.checkedNodes.length==0) {
          this.$message({type: 'warning',message: '请勾选需要添加的设备!'});
          return
        }
        var data=[]
        this.checkedNodes.forEach(item => {
          data.push({
            "deviceId": this.unitItem.id,
            "deviceNO": Number(item.Content.Id)
          })
        })
        var d={
          "data": data,
          "id": Number(this.unitItem.id)
        }
        console.log(data,11);
        request({url: "/gyMes/mesRelevanceDevice",method: "put",data}).then(res => {
          if(res.code==200) {
            this.$message({type: 'success',message: '添加成功!'});
            this.checkedNodes=[]
            this.findUnitInfoFun()
          } else {
            this.$message({type: 'error',message: `添加失败! ${res.message}`});
          }
        })
        return
        dissipationSave(d).then(res => {
          //  console.log("res添加设备",res);
          if(res.code==200) {
            this.$message({type: 'success',message: '添加成功!'});
            this.checkedNodes=[]
            this.$refs.tree.setCheckedKeys([]);
            this.getDeviceList(this.unitItem.id)
          } else {
            this.$message({type: 'error',message: `添加失败! ${res.message}`});
          }
        })



        // console.log("checkedNodes",this.checkedNodes);
        // console.log("12131",this.nodeItem);
      },
    },
  }
</script>

<style lang='scss' scoped>
  .energy-flow {
    width: 100%;
    padding: 8px;
  }

  .con {
    width: 100%;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    overflow: hidden;

    .con-title {
      display: flex;
      align-items: center;
      font-size: 18px;
      margin-left: 10px;
      margin-top: 20px;

      img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
    }

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 20px 12px 12px 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button+.el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }

    }

    .content {
      // flex-grow: 1;
      width: calc(100% - 6rem);
      background-color: #fff;
      border-right: 1px solid #e6e6e6;

      .content-title {
        margin-left: 20px;
        margin-top: 20px;
        font-size: 16px;
        color: #999;
      }

      .mytable {
        width: 84.5%;
        margin: 20px 20px 0px 20px;


      }

      .conten-btns {
        margin-top: 200px;
        transform: translateX(-10px);

        // button {
        //    margin-bottom: 20px;
        // }
        div {
          width: 0.88rem;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          border-radius: 2px;
          background-color: #409EFF;
          color: #fff;
          margin-bottom: 40px;
          cursor: pointer;

          img {
            width: 0.2rem;
            height: 0.2rem;
            margin-left: 0.1rem;
          }
        }

      }
    }

    .tree-right {
      width: 3rem;
      height: 100%;
      background-color: #fff;
      padding: 20px 12px 12px 20px;
      box-sizing: border-box;
    }
  }
</style>